module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tc-0d16f864a483488586df2212e962475a.svg";